import { render, staticRenderFns } from "./TuitionTutorialMobile.vue?vue&type=template&id=70f02706&scoped=true&"
import script from "./TuitionTutorialMobile.vue?vue&type=script&lang=ts&"
export * from "./TuitionTutorialMobile.vue?vue&type=script&lang=ts&"
import style0 from "./TuitionTutorialMobile.vue?vue&type=style&index=0&id=70f02706&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f02706",
  null
  
)

export default component.exports